import {Timeline, TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {IImmortalFruitsWinRatioConfig} from "../../ImmortalFruitsGameConfig";
import {ImmortalFruitsGameModuleConfig} from "../../ImmortalFruitsGameModuleConfig";
import {ImmortalFruitsGameMode} from "../../ImmortalFruitsGameMode";

export class BigWinStep implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _fromRatioConfig: IImmortalFruitsWinRatioConfig;
    private _toRatioConfig: IImmortalFruitsWinRatioConfig;
    private _hasWin: boolean;
    private _countFrom: number;
    private _countTo: number;
    private _lastLevel: boolean;
    private _lastLevelCount: number;
    private _lastLevelRemainderRatio: number;

    /**
     * @constructs
     * @param fromRatioConfig
     * @param toRatioConfig
     * @param stagger
     * @param abortStagger
     */
    constructor(fromRatioConfig: IImmortalFruitsWinRatioConfig, toRatioConfig: IImmortalFruitsWinRatioConfig, stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._fromRatioConfig = fromRatioConfig;
        this._toRatioConfig = toRatioConfig;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: ParsedGameData): void {
        this._hasWin = false;
        this._countFrom = 0;
        this._countTo = 0;
        this._lastLevel = false;
        this._lastLevelCount = 0;
        this._lastLevelRemainderRatio = 0;

        if (data) {
            if (data.singleWin <= 0) {
                return;
            }

            const currentWinRatio = data.singleWin / data.playedBetValue;
            this._hasWin = currentWinRatio >= this._toRatioConfig.ratio;
            this._countFrom = data.playedBetValue * this._fromRatioConfig.ratio;
            this._countTo = data.playedBetValue * this._toRatioConfig.ratio;

            if (data.currentWinRatioConfig && data.currentWinRatioConfig === this._toRatioConfig) {
                this._lastLevel = true;
                this._lastLevelCount = data.singleWin;
                const remainder: number = this._lastLevelCount - this._countTo;
                this._lastLevelRemainderRatio = remainder / data.playedBetValue;

                this._countTo = this._lastLevelCount;
            }
        }
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedServerData): Timeline | null {
        if (!this._hasWin || ImmortalFruitsGameModuleConfig.featurePrice.isWinBelowStake()) {
            return null;
        }

        const tl: TimelineLite = new TimelineLite();
        let count: TimelineLite = new TimelineLite();
        const winTextStart: TimelineLite = ImmortalFruitsGameModuleConfig.winTextView.getStartAnimation(this._toRatioConfig,this._lastLevel);
        if(this._lastLevel){
             count = ImmortalFruitsGameModuleConfig.countUpView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration-0.9, undefined, true, data.mode == ImmortalFruitsGameMode.BONUS_WHEEL);
        }else {
            count = ImmortalFruitsGameModuleConfig.countUpView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration, undefined, true, data.mode == ImmortalFruitsGameMode.BONUS_WHEEL);
        }

        // if(data.mode == ImmortalFruitsGameMode.BONUS_WHEEL && this._toRatioConfig.type === WinRatioType.BIG_WIN){
        //     SoundManager.fadeOutBonusBG(500);
        // }

        tl.add([
            winTextStart,
            count,
        ]);

        // const winTextEnd: TimelineLite = ImmortalFruitsGameModuleConfig.winTextView.getEndAnimation(this._toRatioConfig);
        // tl.add(winTextEnd, tl.totalDuration() - winTextEnd.duration());
        //
         return tl;
    }

    /**
     * @inheritDoc
     * @param isActive
     */
    public abort(isActive: boolean): Timeline | null {
        if (!this._hasWin) {
            return null;
        }

        const tl: TimelineLite = new TimelineLite();

        let count;
        if (this._lastLevel) {
            count = ImmortalFruitsGameModuleConfig.countUpView.abort(this._lastLevelCount);
             ImmortalFruitsGameModuleConfig.winTextView.abort(this._toRatioConfig);
        } else {
            count = ImmortalFruitsGameModuleConfig.countUpView.abort(this._countTo);
        }

        tl.add([
            count
        ]);

        return tl;
    }

}